<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: bisque;">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Add Reviewer</span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="content-header">
                <p>Enter details of new reviewer and click the add button.</p>
                <mat-divider></mat-divider>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="page-content">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 ">
                    <div class="row mt-2">
                      <!-- Email -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-label>Email</mat-label>
                          <input matInput>
                        </mat-form-field>
                      </div>
                      <!-- Username -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-label>Username</mat-label>
                          <input matInput>
                        </mat-form-field>
                      </div>
                      <!-- Password -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-label>Password</mat-label>
                          <input matInput>
                        </mat-form-field>
                      </div>
                      <!-- First Name -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-label>First Name</mat-label>
                          <input matInput>
                        </mat-form-field>
                      </div>
                      <!-- Middle Initial -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-label>Middle Initial</mat-label>
                          <input matInput>
                        </mat-form-field>
                      </div>
                      <!-- Last Name -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-label>Last Name</mat-label>
                          <input matInput>
                        </mat-form-field>
                      </div>
                      <!-- Suffix -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-label>Suffix</mat-label>
                          <input matInput>
                        </mat-form-field>
                      </div>
                      <!-- Institution -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-label>Institution</mat-label>
                          <input matInput>
                        </mat-form-field>
                      </div>
                      <!-- Category -->
                      <div class="col-lg-6 col-md-6 col-sm-12">
                        <mat-form-field appearance="outline" color="accent" class="full-width">
                          <mat-label>Category</mat-label>
                          <mat-select>
                            <mat-option>Degree</mat-option>
                            <mat-option>Diploma</mat-option>
                            <mat-option>Certificate</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div>
                      <button mat-raised-button class="update-button">
                        <a mat-button>Submit</a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>